import { ref } from 'vue';

export const isDarkTheme = ref(false);
